// extracted by mini-css-extract-plugin
module.exports = {"background":"CPSales_background__ACMWb","container":"CPSales_container__GJpuM"};